import { Controller } from "@hotwired/stimulus"
import { initApplicant, trackStep } from "../lib/applicant"

// Stamps the pre-registration funnel as the visitor moves through the two-step
// signup. On /signup it just creates the applicant; on /signup/:role it also
// stamps the chosen role. The email field reports the email step on blur.
export default class extends Controller {
  static values = { role: String }

  async connect() {
    await initApplicant()
    if (this.hasRoleValue && this.roleValue) {
      trackStep("role", { role: this.roleValue })
    }
  }

  email() {
    trackStep("email")
  }
}
